import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRotate = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 960 960",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(0, 960)",
		children: /* @__PURE__ */ _jsx("path", { d: "M528-84q-52 0-98.5-14.5T343-140l52-52q29 17 63 26.5t70 9.5q109 0 186.5-77.5T792-420q0-109-77.5-187.5T522-684l57 57-51 51-144-144 144-144 51 51-57 57q144-3 243 96.5T864-420q0 70-26.5 131t-72 106.5Q720-137 659-110.5T528-84Zm-240-96L48-420l240-240 240 240-240 240Zm0-102 138-138-138-138-138 138 138 138Zm0-138Z" })
	})
});
export default SvgRotate;
